// @ts-nocheck

import './styles.css';

import { loadData } from './generateData';
import { loadOptions } from './loadOptions';

import { Network } from 'vis-network';
import '@fontsource/source-sans-3/400.css';
import '@fontsource/source-sans-3/600.css';
import '@fontsource/source-sans-3/700.css';

function doGraph() {
  // ---------- init network ----------
  const container = document.getElementById('network') as HTMLElement;
  const data = loadData();
  const options = loadOptions();
  const network = new Network(container, data, options);

  // Robust resize handling
  let resizeTimer: NodeJS.Timeout;
  const ro = new ResizeObserver(() => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => network.redraw(), 80);
  });
  ro.observe(container);
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => network.redraw(), 80);
  });

  // Click to open URLs
  network.on('click', (params) => {
    if (params.nodes.length) {
      const n = data.nodes.get(params.nodes[0]);
      if (n?.url) window.open(n.url, '_blank', 'noopener');
    } else if (params.edges.length) {
      const e = data.edges.get(params.edges[0]);
      if (e?.url) window.open(e.url, '_blank', 'noopener');
    }
  });

  // // Fit once stabilized
  // network.once('stabilizationIterationsDone', () => {
  //   network.fit({ animation: { duration: 400 } });
  // });

  // Focus Spahn if present
  const focusCandidates = ['spahn', 'Jens_Spahn'];
  for (const cid of focusCandidates) {
    if (data.nodes.get(cid)) {
      network.focus(cid, { scale: 1.2, animation: { duration: 600 } });
      network.selectNodes([cid]);
      break;
    }
  }
}

doGraph();
